import { ChainType, unsafe_getChainTypeFromChainId } from '@polaris/core/models'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useMemo } from 'react'
import {
  cosmosRegistryChainQuery,
  evmRegistryChainQuery,
} from '@/src/queries/keys/chains'

/**
 * Temporarily use this hook to get the chain color for the list row and chain img components
 * TODO: Remove this hook once we can fetch the chain color from the chain metadata
 * The chain type can be provided to serve as a more reliable source of truth for the chain color.
 */
export const useChainColor = (
  chainId: string | undefined,
  chainType?: ChainType,
) => {
  const queryClient = useQueryClient()
  const foundChainType = useMemo(
    () => chainType ?? unsafe_getChainTypeFromChainId(chainId ?? ''),
    [chainId, chainType],
  )

  const { data: chainColor } = useQuery({
    queryKey: [chainId, foundChainType, 'color'],
    staleTime: Number.POSITIVE_INFINITY,
    queryFn: async ({ queryKey }) => {
      const [chainId, foundChainType] = queryKey as [string, ChainType]

      if (!foundChainType || !chainId) return null

      if (foundChainType === ChainType.Solana) {
        return '#9945FF'
      }

      if (foundChainType === ChainType.Bitcoin) {
        return '#F7931A'
      }

      if (foundChainType === ChainType.Cosmos) {
        const data = queryClient.getQueryData(
          cosmosRegistryChainQuery({ chainId: chainId.split(':')[1] }).queryKey,
        )
        return data?.chain?.images?.[0]?.theme?.primary_color_hex ?? null
      }

      if (foundChainType === ChainType.Evm) {
        const data = queryClient.getQueryData(
          evmRegistryChainQuery({ id: chainId.split(':')[1] }).queryKey,
        )
        return data?.chain?.color ?? null
      }

      return null
    },
    enabled: !!foundChainType && !!chainId,
  })

  return { chainColor }
}
